import Immutable from "immutable";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  isFetching: false,
  didInvalidate: false,
  hasStaticCasts: false,
  rawFiles: []
});

function uploadReducer(state = initialState, action) {
  switch (action.type) {
    case types.SIGN_OUT_COMPLETE:
      return initialState;
    case types.WORKAREA_SET:
      return initialState;
    case types.ORGANIZATION_SET:
      return initialState;

    case types.UPLOAD_FILES_INVALIDATE:
      return state.set("didInvalidate", true);

    case types.UPLOAD_FILE_REQUEST:
      return state.update("rawFiles", rawFiles => {
        const rawFilesWithoutCurrent = rawFiles.filter(f => {
          const samefilename = f.get("name") === action.payload.filename;
          const sameext = f.get("ext") === action.payload.ext;
          return !(samefilename && sameext);
        });

        const rawFilesWithPayload = rawFilesWithoutCurrent.push(
          Immutable.fromJS({
            status: "pending",
            name: action.payload.filename,
            ext: action.payload.ext,
            static: !!action.payload.static,
            data: {
              workarea: action.payload.workarea,
              organization: action.payload.organization
            }
          })
        );
        return rawFilesWithPayload;
      });

    case types.UPLOAD_FILE_SUCCESS:
      return state.update("rawFiles", rawFiles =>
        rawFiles.map(f => {
          if (
            f.get("name") === action.payload.filename &&
            f.get("ext") === action.payload.ext
          ) {
            return f.set("status", "success");
          }
          return f;
        })
      );

    case types.UPLOAD_FILE_ERROR:
      return state.update("rawFiles", rawFiles =>
        rawFiles.map(f => {
          if (
            f.get("name") === action.meta.filename &&
            f.get("ext") === action.meta.ext
          ) {
            return f.merge({
              status: "error",
              message: action.payload.message
            });
          }
          return f;
        })
      );

    case types.TOGGLE_HAS_STATIC_CASTS:
      return state.set("hasStaticCasts", action.payload);

    default:
      return state;
  }
}

export default uploadReducer;
